import { Injectable } from '@angular/core';
import { RestService } from '@abp/ng.core';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  apiName = 'Inventory';

  constructor(private restService: RestService) {}

  sample() {
    return this.restService.request<void, any>(
      { method: 'GET', url: '/api/Inventory/sample' },
      { apiName: this.apiName }
    );
  }
}
